import { useContext } from "react";
import PermissionContext from "../../../store/PermissionContext";

const CheckMultiplePermission = ({ permissions, children }) => {
      const permissionCtx = useContext(PermissionContext);
      const userPermissions = permissionCtx?.userPermissions;

      return (
            userPermissions &&
            Array.isArray(userPermissions) &&
            permissions.some((permission) =>
                  userPermissions.includes(permission)
            ) &&
            children
      );
};

export default CheckMultiplePermission;
